import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import {
    KYC_MODAL_ERROR_MISSING_DATA,
    KYC_MODAL_STEP_ERROR,
    KYC_MODAL_STEP_IN_PROGRESS,
    KYC_USE_CASE_WAITING_TRANSACTION
} from '../../../services/kyc/constants';
import { STATIC_ROOT } from '../../../constants';

import { initializeKyc, fetchKycState } from '../../../services/kyc/actions';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';
import { getUserId, getClickId, getLastUserInfoStored } from '../../../utils/plebicardUtils';

import ButtonComponent from '../../button/ButtonComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';

const KycStep1 = ({
    i18n,
    kycWidgetLink,
    fetchingLink,
    errorLink,
    userId,
    initializeKyc,
    fetchKycState,
    setStep,
    setErrorType,
    useCase
}) => {
    useEffect(() => {
        if (kycWidgetLink) {
            setStep(KYC_MODAL_STEP_IN_PROGRESS);

            startCheckingKycState();
            window.open(kycWidgetLink, '_blank');
        } else if (errorLink) {
            setErrorType(KYC_MODAL_ERROR_MISSING_DATA);
            setStep(KYC_MODAL_STEP_ERROR);
        }
    }, [kycWidgetLink]);

    const getWidgetLink = () => {
        const clickId = getClickId();
        const userInfo = getLastUserInfoStored();

        if (userInfo && userInfo.email) {
            const kycRequest = {
                firstname: userInfo.firstname,
                lastname: userInfo.lastname,
                mobileNumber: userInfo.phoneNumber
            };

            initializeKyc(userInfo.email, userId, clickId, kycRequest);
        } else {
            setErrorType(KYC_MODAL_ERROR_MISSING_DATA);
            setStep(KYC_MODAL_STEP_ERROR);
        }
    };

    const startCheckingKycState = () => {
        const clickId = getClickId();
        const userInfo = getLastUserInfoStored();

        fetchKycState(userInfo.email, userId, clickId);
    };

    return (
        <div>
            <h3>{i18n.TITLE}</h3>
            <div className="body">
                {useCase === KYC_USE_CASE_WAITING_TRANSACTION ? (
                    <p>{convertHtmlToReactDomWithParams(i18n.WAITING_TRANSACTION.TEXT_1)}</p>
                ) : (
                    <p>{convertHtmlToReactDomWithParams(i18n.DEFAULT.TEXT_1)}</p>
                )}
                <p className="italic">{i18n.TEXT_2}</p>

                <div className="button-wrapper">
                    {fetchingLink ? (
                        <LoadingComponent />
                    ) : (
                        <ButtonComponent
                            color="main"
                            text={i18n.BUTTON_TEXT}
                            onClick={getWidgetLink}
                        />
                    )}
                </div>

                <p>{convertHtmlToReactDomWithParams(i18n.TEXT_3)}</p>
                <div className="ubble">
                    <div>{i18n.TEXT_4}</div>
                    <div>
                        <img
                            src={`${STATIC_ROOT}/kyc/ubble.png`}
                            alt="Ubble logo"
                            width="100"
                            height="37"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.FRAUD.KYC_MODAL.STEP_1,
        kycWidgetLink: state.kyc.widgetLink,
        fetchingLink: state.kyc.fetchingLink,
        errorLink: state.kyc.errorLink,
        userId: getUserId(state)
    };
};

const mapDispatchToProps = {
    initializeKyc,
    fetchKycState
};

export default connect(mapStateToProps, mapDispatchToProps)(KycStep1);



// WEBPACK FOOTER //
// ./src/components/fraud/kyc/KycStep1.js